import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { APIError } from '../../../../../utils'
import { fetchNextAvailableAccountNumber } from '../query-api'

interface UseFetchNextAvailableAccountNumberOptions {
  onError?: (error: APIError) => void
  organizationId: string | undefined
  predefinedAccountId: string
}

export const useFetchNextAvailableAccountNumber = ({
  onError,
  organizationId,
  predefinedAccountId,
}: UseFetchNextAvailableAccountNumberOptions) => {
  const isEnabled = Boolean(organizationId && predefinedAccountId)

  const {
    data: nextAvailableAccountNumber,
    isFetching,
    refetch,
  } = useQuery(
    [QueryKeys.NextAvailableAccountNumber, organizationId, predefinedAccountId],
    () =>
      fetchNextAvailableAccountNumber({
        organizationId: organizationId as string,
        predefinedAccountId,
      }),
    {
      enabled: isEnabled,
      onError,
      retry: false,
      select: ({ nextFreeNumber }) => nextFreeNumber,
    },
  )

  return { isFetching, nextAvailableAccountNumber, refetch }
}
